import { PageType } from "@snapchat/web-blizzard-reporting";
import { ConsumerApp } from "@snapchat/web-consumer-nav";
import { generateAttributedDownloadUrl, PageFrame, ResponsiveSSRPage, Shell, useMobileMediaQuery, } from "@snapchat/web-frame";
import { getCountryFromLocale, getDirectionForLocale, useLocale } from "@snapchat/web-i18n";
import { NoContent, Reason } from "@snapchat/web-no-content-page";
import { useGenerateWebPageViewTraceId } from "@snapchat/web-page-view";
import { useCreateOrUpdateWebClientId, useEssentialSession } from "@snapchat/web-sc-cookies";
import { incrementCountsByPageAndCountry } from "@snapchat/web-graphene-reporting";
import { useEffect, useMemo, useRef } from "react";
import { LENS_DOT_SNAPCHAT_DOT_COM_GA } from "../../constants/ga";
import { grafanaBasePrefix } from "../../lib/grafana";
import { getBaseShellProps } from "../../lib/shell";
import { loadMessages } from "../../i18n/messages";
/**
 * Generic 404, content not found page.
 */
function NotFound() {
    const PAGE_NAME = "NOT_FOUND";
    const { locale, messages, changeLocale } = useLocale({
        loadMessages,
    });
    const countryRef = useRef(getCountryFromLocale(locale));
    countryRef.current = useMemo(() => getCountryFromLocale(locale), [locale]);
    const pageType = PageType.NOT_FOUND;
    useEssentialSession();
    // NOT FOUND pages are static pages and thus should be treated as requests coming from GDPR countries
    const webClientId = useCreateOrUpdateWebClientId({
        isGdpr: true,
    });
    const { traceId } = useGenerateWebPageViewTraceId();
    const isMobile = useMobileMediaQuery();
    useEffect(() => {
        void incrementCountsByPageAndCountry(grafanaBasePrefix, PAGE_NAME, 1, countryRef.current);
    }, []);
    const baseShellProps = useMemo(() => getBaseShellProps(), []);
    return (<Shell locale={locale} direction={getDirectionForLocale(locale)} messages={messages} country={countryRef.current} title="Snapchat" pageMetadata={{
            pageType: PageType.NOT_FOUND,
        }} gaid={LENS_DOT_SNAPCHAT_DOT_COM_GA} webClientId={webClientId} webPageViewTraceId={traceId} {...baseShellProps}>
      <PageFrame locale={locale} localeChange={changeLocale} appType={ConsumerApp.Lens} pageType={pageType} downloadUrl={generateAttributedDownloadUrl(pageType)} isMobile={isMobile} webClientId={webClientId}>
        <NoContent pageType={pageType} locale={locale} changeLocale={changeLocale} reason={Reason.CONTENT_NOT_FOUND} hideFooter // footer is rendered via pageframe.
    />
      </PageFrame>
    </Shell>);
}
function NotFoundWrapper() {
    return (<ResponsiveSSRPage isMobileServerSide>
      <NotFound />
    </ResponsiveSSRPage>);
}
export { NotFoundWrapper as NotFound };
